export const colorMappingWarnDanger = (value: number): string => {
  const mapping = {
    0: '#99cc60',
    1: '#fff176',
    2: '#f9715f',
    3: '#e14b7e',
  };
  return mapping.hasOwnProperty(value) ? mapping[value] : mapping[0];
};

export const colorMappingCond = (
  value: number,
  detailsToShow?: boolean
): string => {
  const mapping = {
    19: '',
    0: 'routenprognose-cond-green',
    1: 'routenprognose-cond-green',
    2: 'routenprognose-cond-moist',
    3: 'routenprognose-cond-wet',
    4: 'routenprognose-cond-nass',
    5: 'routenprognose-cond-reif-less',
    6: 'routenprognose-cond-blackIce-less',
    7: 'routenprognose-cond-eis-less',
    8: 'routenprognose-cond-snow-less',
    9: 'routenprognose-cond-reif',
    10: 'routenprognose-cond-blackIce',
    11: 'routenprognose-cond-eis',
    12: 'routenprognose-cond-snow',
    13: 'routenprognose-cond-snow',
    14: 'routenprognose-cond-reif-more',
    15: 'routenprognose-cond-blackIce-more',
    16: 'routenprognose-cond-eis-more',
    17: 'routenprognose-cond-snow-more',
    18: 'routenprognose-cond-snow-more',
  };
  return mapping.hasOwnProperty(value) || (detailsToShow && value === 0)
    ? mapping[value]
    : mapping[19];
};

export const colorMappingTemp = (value: number): string => {
  const mapping = {
    0: 'temp-color-green',
    1: 'temp-color-yellow1',
    2: 'temp-color-yellow2',
    3: 'temp-color-red',
    4: 'temp-color-darkred',
    5: 'temp-color-purpel',
  };
  return mapping.hasOwnProperty(value) ? mapping[value] : mapping[0];
};

export const colorMappingWarn = (value: number): string => {
  const mapping = {
    0: 'warn-color-green',
    1: 'warn-color-yellow',
    2: 'warn-color-orange',
    3: 'warn-color-red',
  };
  return mapping.hasOwnProperty(value) ? mapping[value] : mapping[0];
};
